import type { JSX } from 'react'

import { TextBox, TextBoxColors, TextBoxTypes } from "/app/libraries/arcana/src/atoms/TextBox/index.ts"

import { useUnit } from 'effector-react'
import { useTranslation } from 'react-i18next'
import { $getToaLoading, $toa, $wasLoadingError, error } from '../model'

import classes from '~/routes/auth/toa/ui/style.module.css'

export const BodyTextBlock = (): JSX.Element => {
  const { t } = useTranslation()

  const { toa, err, wasLoadingError, getToaLoading } = useUnit({
    toa: $toa,
    err: error.$loading,
    wasLoadingError: $wasLoadingError,
    getToaLoading: $getToaLoading,
  })

  if (toa) {
    return (
      <TextBox
        font={TextBoxTypes.FontSm}
        color={TextBoxColors.TEXT_ICON_PRIMARY}
        title={toa.message}
      />
    )
  }

  if (err || wasLoadingError) {
    return <></>
  }

  if (getToaLoading) {
    return (
      <div className={classes.wrap}>
        <div className={classes.loader}></div>
        <TextBox
          title={t('loading')}
          font={TextBoxTypes.FontSm}
          color={TextBoxColors.TEXT_ICON_SECONDARY}
        />
      </div>
    )
  }

  return <></>
}
